import { type AgentDefinition, MEDIUM_BUDGET, TOOLS } from './types.js';
import { agentPrompt } from './agent-prompts.js';

/** Phase 8 · Delivery & Ops — ship it, run it, keep it healthy. */
export const DELIVERY_AGENTS: AgentDefinition[] = [
  {
    config: {
      id: 'git',
      name: 'Git',
      role: 'git',
      tools: [...TOOLS.vcs, 'bash'],
      prompt: agentPrompt('git'),
    },
    budget: MEDIUM_BUDGET,
    capability: {
      phase: 'delivery',
      summary: 'Git automation: focused commits, branch/rebase/conflict handling, PR prep, history investigation.',
      keywords: [
        'git',
        'commit',
        'branch',
        'rebase',
        'merge',
        'pull request',
        'pr',
        'conflict',
        'blame',
        'bisect',
        'cherry-pick',
        'stash',
      ],
    },
  },
  {
    config: {
      id: 'release',
      name: 'Release',
      role: 'release',
      tools: [...TOOLS.vcs, 'bash', 'json'],
      prompt: agentPrompt('release'),
    },
    budget: MEDIUM_BUDGET,
    capability: {
      phase: 'delivery',
      summary: 'Release management: semver bumps, changelogs, and release notes derived from real history.',
      keywords: [
        'release',
        'version',
        'semver',
        'changelog',
        'release notes',
        'tag',
        'bump version',
        'publish',
        'versioning',
      ],
    },
  },
  {
    config: {
      id: 'devops',
      name: 'DevOps',
      role: 'devops',
      tools: [
        ...TOOLS.build,
        'mcp__ssh__ssh_list_servers',
        'mcp__ssh__ssh_connection_status',
        'mcp__ssh__ssh_execute',
        'mcp__ssh__ssh_execute_sudo',
        'mcp__ssh__ssh_upload',
        'mcp__ssh__ssh_download',
        'mcp__ssh__ssh_sync',
        'mcp__ssh__ssh_deploy',
        'mcp__ssh__ssh_health_check',
        'mcp__ssh__ssh_service_status',
        'mcp__ssh__ssh_process_manager',
        'mcp__ssh__ssh_tunnel',
        'mcp__ssh__ssh_backup_create',
        'mcp__ssh__ssh_backup_list',
        'mcp__ssh__ssh_backup_restore',
        'mcp__ssh__ssh_db_list',
        'mcp__ssh__ssh_db_query',
        'mcp__ssh__ssh_profile',
      ],
      prompt: agentPrompt('devops'),
    },
    budget: MEDIUM_BUDGET,
    capability: {
      phase: 'delivery',
      summary: 'CI/CD, containerization, and deployment config: reproducible builds and safe deploys with rollback.',
      keywords: [
        'devops',
        'ci',
        'cd',
        'ci/cd',
        'pipeline',
        'docker',
        'dockerfile',
        'kubernetes',
        'k8s',
        'deploy',
        'ssh',
        'remote ssh',
        'remote server',
        'sftp',
        'tunnel',
        'bastion',
        'jump host',
        'github actions',
        'container',
      ],
    },
  },
  {
    config: {
      id: 'observability',
      name: 'Observability',
      role: 'observability',
      tools: [...TOOLS.build, 'logs'],
      prompt: agentPrompt('observability'),
    },
    budget: MEDIUM_BUDGET,
    capability: {
      phase: 'delivery',
      summary: 'Observability: structured logging, metrics, distributed tracing, and alerts/dashboards.',
      keywords: [
        'observability',
        'logging',
        'metrics',
        'tracing',
        'telemetry',
        'opentelemetry',
        'otel',
        'prometheus',
        'monitoring',
        'alert',
        'dashboard',
        'instrument',
      ],
    },
  },
  {
    config: {
      id: 'dependency',
      name: 'Dependency',
      role: 'dependency',
      tools: [...TOOLS.deps, 'bash'],
      prompt: agentPrompt('dependency'),
    },
    budget: MEDIUM_BUDGET,
    capability: {
      phase: 'delivery',
      summary: 'Package management + supply-chain safety: CVE audit, safe upgrades, pruning, install-script review.',
      keywords: [
        'dependency',
        'dependencies',
        'package',
        'npm',
        'pnpm',
        'cve',
        'vulnerability scan',
        'upgrade deps',
        'audit',
        'supply chain',
        'outdated',
        'lockfile',
      ],
    },
  },
];
